import { categories } from "@/mocks/categories";
import { sites, type Site } from "@/mocks/sites";

export function formatVisits(n: number): string {
  if (n >= 10000) {
    const w = n / 10000;
    return `${w.toFixed(1).replace(/\.0$/, "")}万`;
  }
  return String(n);
}

export function getHost(url: string): string {
  try {
    return new URL(url).hostname.replace(/^www\./, "");
  } catch {
    return url;
  }
}

export function getCategoryById(id: string) {
  return categories.find((c) => c.id === id);
}

export function getSiteById(id: string) {
  return sites.find((s) => s.id === id);
}

export function getSitesByCategory(categoryId: string): Site[] {
  return sites.filter((s) => s.categoryId === categoryId);
}

export function countByCategory(categoryId: string): number {
  return getSitesByCategory(categoryId).length;
}

export function getHotSites(limit = 24): Site[] {
  return [...sites].sort((a, b) => b.visits - a.visits).slice(0, limit);
}

export function getFeaturedSites(): Site[] {
  return sites.filter((s) => s.featured);
}

export function getNewSites(): Site[] {
  return sites
    .filter((s) => s.isNew)
    .sort((a, b) => (a.updatedAt < b.updatedAt ? 1 : -1));
}

export function searchSites(keyword: string): Site[] {
  const kw = keyword.trim().toLowerCase();
  if (!kw) return [];
  return sites.filter((s) => {
    const categoryName = getCategoryById(s.categoryId)?.name ?? "";
    return (
      s.name.toLowerCase().includes(kw) ||
      s.desc.toLowerCase().includes(kw) ||
      s.detail.toLowerCase().includes(kw) ||
      s.tags.some((t) => t.toLowerCase().includes(kw)) ||
      categoryName.toLowerCase().includes(kw)
    );
  });
}

export function getRelatedSites(site: Site, limit = 6): Site[] {
  return sites
    .filter(
      (s) =>
        s.id !== site.id &&
        (s.categoryId === site.categoryId ||
          s.tags.some((t) => site.tags.includes(t)))
    )
    .slice(0, limit);
}

export function sortSites(list: Site[], by: string): Site[] {
  const copy = [...list];
  if (by === "visits") return copy.sort((a, b) => b.visits - a.visits);
  if (by === "updated") return copy.sort((a, b) => (a.updatedAt < b.updatedAt ? 1 : -1));
  if (by === "name") return copy.sort((a, b) => a.name.localeCompare(b.name, "zh-Hans-CN"));
  return copy;
}